import { SystemMessageActions } from "actions";
import _ from "lodash";

const initState = {
  msgType: "",
  msg: "",
  data: {},
};

export const systemMessage = (state = initState, action) => {
  switch (action.type) {
    case SystemMessageActions.CAPTURE_SYSTEM_ERROR:
      return {
        msgType: action.msgType,
        msg: action.msg,
        data: _.cloneDeep(action.data),
      };
    case SystemMessageActions.CLEAR_SYSTEM_MESSAGE:
      return {
        ...initState,
        data: {},
      };
  }
  return state;
};



// WEBPACK FOOTER //
// ./reducers/systemMessageReducers.js